export const RecordingStatus = {
    NONE: "NONE", // レコードしていない
    START: "START", // 開始の指示
    IN_PROGRESS: "IN_PROGRESS", // 記録中
    COMPLETED: "COMPLETED" // 記録完了
};